export const actions = {
    GET_HELP_DATA: 'GET_HELP_DATA',
    GET_HELP_DATA_SUCCESS: 'GET_HELP_DATA_SUCCESS',
    GET_HELP_DATA_FAILED: 'GET_HELP_DATA_FAILED',
    GET_THE_APP_CLICKED: 'GET_THE_APP_CLICKED',
}

export const getHelpDetails = language => ({
    type: actions.GET_HELP_DATA,
    payload: {
        language,
    },
})

export const getHelpDataSuccess = helpData => ({
    type: actions.GET_HELP_DATA_SUCCESS,
    payload: helpData,
})

export const getHelpDataFailed = () => ({
    type: actions.GET_HELP_DATA_FAILED,
})

export const getTheAppClicked = () => ({
    type: actions.GET_THE_APP_CLICKED,
})
